import { render, staticRenderFns } from "./PurchaseOrderDetailsTable.vue?vue&type=template&id=c30246cc&scoped=true&"
import script from "./PurchaseOrderDetailsTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderDetailsTable.vue?vue&type=style&index=0&id=c30246cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30246cc",
  null
  
)

export default component.exports